
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives",
      function () {
        return require("private-next-pages/signature/alternatives/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/alternatives"])
      });
    }
  